import { BreadCrumbsWithTitle } from '../BreadCrumbsWithTitle/BreadCrumbsWithTitle.js';
import { DetailsWrapper } from '../DetailsWrapper/index.js';
import { DeliveryOrderDetailsAddons } from './DeliveryOrderDetailsAddons.js';
import { DeliveryOrderDetailsDelivery } from './DeliveryOrderDetailsDelivery.js';
import { DeliveryOrderDetailsGeneral } from './DeliveryOrderDetailsGeneral.js';
import { DeliveryOrderDetailsProduct } from './DeliveryOrderDetailsProduct.js';
import { DeliveryOrderDetailsUser } from './DeliveryOrderDetailsUser.js';
import type { CustomerOrder, DeliveryOrder } from '../../generated/api/models.js';
import type { BreadCrumbList } from '../BreadCrumbs/BreadCrumbs.js';

import './DeliveryOrderDetails.scss';

export interface DeliveryOrderDetailsProps {
  breadCrumbPaths?: BreadCrumbList;
  customerOrder: CustomerOrder;
  deliveryOrder: DeliveryOrder;
  firstBreadCrumbName?: string;
  isApprover: boolean;
  mdmId?: string;
  showOrderConfirmationDownload?: boolean;

  onClickCustomerOrder: () => void;
}

export const DeliveryOrderDetails = ({
  customerOrder,
  deliveryOrder,
  breadCrumbPaths,
  onClickCustomerOrder,
  isApprover,
  mdmId,
  showOrderConfirmationDownload = true,
}: DeliveryOrderDetailsProps) => {
  const { deliveryOrderDisplayId, deliveryOrderName, details, purposeOfUse, userContactName } = deliveryOrder;

  const breadCrumbs = breadCrumbPaths && <BreadCrumbsWithTitle breadCrumbPaths={breadCrumbPaths} />;
  const detailsSection = details ? (
    <>
      <DeliveryOrderDetailsGeneral
        customerOrder={customerOrder}
        deliveryOrder={deliveryOrder}
        details={details}
        onClickCustomerOrder={onClickCustomerOrder}
        isApprover={isApprover}
        mdmId={mdmId}
      />
      <DeliveryOrderDetailsProduct
        productType={deliveryOrder.productType}
        details={details}
        deliveryOrderName={deliveryOrderName}
        customerOrderDisplayId={customerOrder.customerOrderDisplayId}
        showOrderConfirmationDownload={showOrderConfirmationDownload}
      />
      <DeliveryOrderDetailsUser userContactName={userContactName} purposeOfUse={purposeOfUse} />
      <DeliveryOrderDetailsDelivery details={details} />
      <DeliveryOrderDetailsAddons details={details} commercialProductName={deliveryOrderName} />
    </>
  ) : null;
  return (
    <DetailsWrapper
      classes={['of-delivery-order-details']}
      detailsTop={breadCrumbs}
      heading={deliveryOrderName}
      heroWhiteBackground={true}
      id={`delivery-order-${deliveryOrderDisplayId}`}
    >
      <div className="of-delivery-order-details__content">{detailsSection}</div>
    </DetailsWrapper>
  );
};
